
import { Button } from "@/components/Button";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const StrategyHero = () => {
  return (
    <section className="relative pt-32 pb-20 overflow-hidden">
      {/* Background elements */}
      <div className="absolute inset-0 bg-gradient-to-b from-background via-background/95 to-background/80 z-0"></div>
      
      {/* Background image */}
      <div className="absolute inset-0 z-0">
        <img 
          src="/lovable-uploads/Strategy_session.jpg"
          alt="AI Strategy Session"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background/70 to-background/70"></div>
      </div>
      
      <div className="container mx-auto relative z-10 px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 tracking-tight">
            The Firms That Win Tomorrow Are Building Their <span className="text-gradient">AI Strategy</span> Today
          </h1>
          
          <p className="text-lg md:text-xl text-white/80 mb-8 max-w-3xl mx-auto">
            Don't let your firm get left behind. Our expert consultants help you create a custom AI adoption roadmap — minimizing risk, maximizing opportunity, and future-proofing your practice before the window closes.
          </p>
          
          <div className="flex justify-center">
            <Link to="/services/strategy/free-discovery-session">
              <Button variant="glass" size="lg" className="text-base">
                Book Your Free Discovery Session
                <ArrowRight className="ml-2 h-5 w-5" />
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StrategyHero;
